export const ace = {
  nome: 'ACE (Agente Comunitário de Endemias)',
  id_perfil: 10,
  dashboard: [
    {
      link: '/gestao-cadastros',
      titulo: 'Gestão cadastros',
      icone: false,
      imagem: '',
      svg: 'GestaoCadastros',
      key: 'gestao_cadastros',
    },
    {
      link: '/aedes-aegypti/equipe/acs',
      titulo: 'Aedes aegypti',
      icone: false,
      imagem: '',
      svg: 'AedesAegypti',
      key: 'aedes_aegypti',
    },
  ],
  administracao: [],
  gestao_cadastros: [
    {
      link: '/acs-por-cidadao',
      titulo: 'Cidadão',
      icone: 'icofont-users-alt-4',
      key: 'cidadao',
    },
  ],
  visitas_domiciliares: [],
  imunizacao: [],
  vacina_idade_certa: [],
  divergencia_vacinas: [],
  indicadores_aps: [],
  pre_natal: [],
  doencas_cronicas: [],
  desempenho_por_equipe: [],
  saude_crianca: [],
  indicadores_esb: [],
  indicadores_esb_estrategicos: [],
  indicadores_esb_ampliados: [],
  producao: [],
  vinculo_acompanhamento: [],
  bpa_e_ras: [],
}
